import { MiddlewareAPI, Dispatch, AnyAction } from "redux";
import { Socket } from "socket.io-client";

import { MessagesConversation, ReceiveMessage } from "slices/messages";

import * as messagesActions from "slices/messages";

import { MessagesEvent } from "./types";

const addSocketListeners = (
  store: MiddlewareAPI<Dispatch<AnyAction>, any>,
  socket: Socket,
): void => {
  socket.on("connect", () => {
    store.dispatch(messagesActions.connectionEstablished());
    store.dispatch(messagesActions.getAllConversations());
  });

  socket.on("connect_error", (error) => {
    console.log("connect_error", error);
    if (!socket.active) {
      store.dispatch(messagesActions.connectionFailed());
    }
  });

  socket.on("disconnect", (reason) => {
    console.log("disconnect", reason);
    if (!socket.active) {
      store.dispatch(messagesActions.connectionDisconnected());
    }
  });

  socket.on(
    MessagesEvent.ReceiveConversation,
    (conversation: MessagesConversation) => {
      store.dispatch(messagesActions.receiveConversation({ conversation }));
    },
  );

  socket.on(
    MessagesEvent.ReceiveConversationUpdate,
    (conversation: MessagesConversation) => {
      store.dispatch(
        messagesActions.receiveConversationUpdate({ conversation }),
      );
    },
  );

  socket.on(MessagesEvent.ReceiveMessage, (payload: ReceiveMessage) => {
    store.dispatch(messagesActions.receiveMessage(payload));
  });
};

export default addSocketListeners;
